import { Children } from 'react';
import Dropdown from '../Dropdown';
import Icon from '../Icon';

import './styles.scss';

/**
 * Renders a row of badges, showing at most `limit` inline. Any extra badges
 * are moved into a dropdown so the row never wraps. The dropdown toggle shows
 * "Mais Filtros" by default, or a tag icon + overflow count when
 * `variant="tags"`.
 */
const BadgeCollapse = ({ limit = 3, variant, align = 'right', children }) => {
  const badges = Children.toArray(children);

  if (badges.length <= limit) {
    return badges;
  }

  const visible = badges.slice(0, limit);
  const overflow = badges.slice(limit);

  const button = variant === 'tags'
    ? <>
        <Icon id="tag" size="14" />
        +{overflow.length}
      </>
    : <>
        <Icon id="icon-contrast" size="14" />
        Mais Filtros
      </>;

  return (
    <>
      {visible}
      <Dropdown className="badge-list-more" align={align} button={button}>
        {overflow}
      </Dropdown>
    </>
  );
};

export default BadgeCollapse;
